import { PropertyType } from 'components'
import { ImageIcon } from 'components/common/atoms'
import { Bathroom } from 'components/common/molecules/bathroom'
import { Bedroom } from 'components/common/molecules/bedroom'
import { List } from 'components/common/molecules/list'
import { SquareFeet } from 'components/common/molecules/squareFeet'
import { YearBuilt } from 'components/common/molecules/year-built'
import { STATIC_FILES_CDN_URL } from 'constant'
import { useSelector } from 'store'
import { selectPublicListingPropertyDetails } from 'store/public-listing'
import { COLOR } from 'styles/constants'

import {
  apartmentIcon,
  bathroomIcon,
  bedroomIcon,
  manufacturedHomeIcon,
  multiFamilyHomeIcon,
  singleFamilyHomeIcon,
  squareFeetIcon,
  yearBuiltIcon,
} from './constants'
import { IconWrapper, TitleWrapper, Wrapper, ItemWrapper } from './styled'

const pickPropertyIcon = (propertyType: PropertyType): string => {
  switch (propertyType) {
    case 'TOWNHOUSE':
    case 'SINGLE_FAMILY_HOME':
      return `${STATIC_FILES_CDN_URL}${singleFamilyHomeIcon}`
    case 'STUDENT_HOUSING':
    case 'CONDOMINIUM':
    case 'APARTMENT':
      return `${STATIC_FILES_CDN_URL}${apartmentIcon}`
    case 'MANUFACTURED_HOME':
      return `${STATIC_FILES_CDN_URL}${manufacturedHomeIcon}`
    case 'MULTI_FAMILY_HOME':
      return `${STATIC_FILES_CDN_URL}${multiFamilyHomeIcon}`
    default:
      return `${STATIC_FILES_CDN_URL}${singleFamilyHomeIcon}`
  }
}

export const PropertyDetails = () => {
  const propertyDetails = useSelector(selectPublicListingPropertyDetails)

  const { propertyType, bathrooms, bedrooms, squareFeet, yearBuilt } = propertyDetails

  return (
    <Wrapper id="propertyDetailsContainer" $mt={30}>
      <List
        dataSource={[
          {
            id: '01',
            icon: pickPropertyIcon(propertyType),
            value: propertyType,
            component: (value: PropertyDetailsValue, style) => (
              <PropertyType {...style} type={value as PropertyType} />
            ),
          },
          {
            id: '02',
            icon: `${STATIC_FILES_CDN_URL}${bedroomIcon}`,
            value: bedrooms,
            component: (value: PropertyDetailsValue, style) => (
              <Bedroom {...style} bedroom={value as string | number} />
            ),
          },
          {
            id: '03',
            icon: `${STATIC_FILES_CDN_URL}${bathroomIcon}`,
            value: bathrooms,
            component: (value: PropertyDetailsValue, style) => (
              <Bathroom {...style} bathrooms={value as string | number} />
            ),
          },
          {
            id: '04',
            icon: `${STATIC_FILES_CDN_URL}${squareFeetIcon}`,
            value: squareFeet,
            component: (value: PropertyDetailsValue, style) => (
              <SquareFeet {...style} squareFeet={value as string | number} />
            ),
          },
          {
            id: '05',
            icon: `${STATIC_FILES_CDN_URL}${yearBuiltIcon}`,
            value: yearBuilt,
            component: (value: PropertyDetailsValue, style) => (
              <YearBuilt {...style} yearBuilt={value as number | string} />
            ),
          },
        ]}
        renderItem={({ id, icon, value, component }: IPropertyDetailsDataSource) => {
          const titleComponent = component(value, {
            $size: '14px',
            $lineHeight: '20px',
            $weight: '600',
            $block: true,
            $color: COLOR.GREY_LV1,
            $pt: 5,
          })
          return (
            value !== undefined && (
              <ItemWrapper key={id} $mr={0}>
                <IconWrapper>
                  <ImageIcon src={icon} />
                </IconWrapper>
                <TitleWrapper>{titleComponent}</TitleWrapper>
              </ItemWrapper>
            )
          )
        }}
      />
    </Wrapper>
  )
}
